export default __webpack_public_path__ + "static/media/zoom-in.cecc6a0f.svg";